import React from 'react';

// Decode special HTML characters in React templates
export const renderHTML = (rawHTML) =>
  React.createElement('div', { dangerouslySetInnerHTML: { __html: rawHTML } });
